module.exports = __webpack_public_path__ + "static/media/error.2ae3295c.svg";